import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { LoaderStyled } from "./loader.styles";

interface LoaderProps {
  size?: number; 
  absolute?: boolean; 
  color?: string; 
  isCircular?: boolean;
  marginTop?: number;
}

const Loader: React.FC<LoaderProps> = ({
  size = 40,
  absolute = false,
  color = "#2460B8",
  isCircular = true,
  marginTop = 0,
}) => {
  return (
    <LoaderStyled size={size} marginTop={marginTop}>
      <Box
        className={absolute ? "absoluteLoader" : ""}
        data-testid="loading-box"
        aria-label="loading"
        sx={{
          position: absolute ? "absolute" : "static",
          top: absolute ? "50%" : "auto",
          left: absolute ? "50%" : "auto",
          transform: absolute ? "translate(-50%, -50%)" : "none",
        }}
      >
        {isCircular && <CircularProgress size={size} sx={{ color }} />}
      </Box>
    </LoaderStyled>
  );
};

export default Loader;
